<template>
  <mapit-dialog :dialog="dialog" @close="$emit('openClose')">
    <template v-slot:header-icon>
      <v-icon class="text-orange" size="48">fa-solid fa-octagon-xmark</v-icon>
    </template>
    <template v-slot:header-text>
      <span>{{ title || $t(`honda.registration.cancel_popup.title`) }}</span>
    </template>
    <template v-slot:body>
      <div class="text-center" v-html="description || $t(`honda.registration.cancel_popup.description`)" />
    </template>
    <template v-slot:footer-center>
      <v-btn class="btn-primary btn-rounded" data-cy="registration-popup-btn-exit" text @click="$emit('exit')"
        >{{ $t('buttons.exit') }}
      </v-btn>
      <v-btn class="btn-gray btn-rounded" data-cy="registration-popup-btn-cancel" text @click="$emit('openClose')"
        >{{ $t('buttons.cancel') }}
      </v-btn>
    </template>
  </mapit-dialog>
</template>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import MapitDialog from '@/components/dialog/MapitDialog.vue'

export default defineComponent({
  name: 'DialogExitProcess',
  components: {
    MapitDialog,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
  setup() {
    return {}
  },
})
</script>
